<template>
  <MModal
    v-if="open"
    :modal-class="promptType === 'providers' ? 'md:max-w-xl' : 'md:max-w-lg'"
    @close="onClose"
  >
    <div class="bg-white py-6 rounded-12">
      <div v-if="promptType === 'generic'" class="absolute left-0 -mt-6">
        <img class="h-52" src="../images/simple-app-mobile-rotate-left.png" alt="" loading="lazy" />
      </div>
      <div v-else class="absolute left-0 mt-2 pl-6">
        <svg role="presentation" focusable="false" tabindex="-1" class="h-8"   alt="" svg-inline  viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="2.67" fill="#E8FDE5"/><path d="M14.37 11.66a8.66 8.66 0 1 0 0 17.34l8.67-8.67-8.67-8.67Z" fill="#3D843D"/><path d="M14.37 3a8.66 8.66 0 1 0 0 17.33l8.67-8.67L14.37 3Z" fill="#8CC42D"/><path d="m23.04 11.66-4.33 4.33 4.33 4.33L27.37 16l-4.33-4.33ZM14.37 20.33 18.71 16l-4.34-4.34c-3.2 0-6 1.75-7.5 4.34a8.66 8.66 0 0 0 7.5 4.33Z" fill="#65A435"/></svg>
      </div>

      <div class="mx-6 flex" :class="promptType === 'generic' ? 'mt-48' : 'mt-16'">
        <svg role="presentation" focusable="false" tabindex="-1" v-if="promptType === 'generic'"
          class="mr-2 h-6"
           
          alt=""
          svg-inline
         viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="2.67" fill="#E8FDE5"/><path d="M14.37 11.66a8.66 8.66 0 1 0 0 17.34l8.67-8.67-8.67-8.67Z" fill="#3D843D"/><path d="M14.37 3a8.66 8.66 0 1 0 0 17.33l8.67-8.67L14.37 3Z" fill="#8CC42D"/><path d="m23.04 11.66-4.33 4.33 4.33 4.33L27.37 16l-4.33-4.33ZM14.37 20.33 18.71 16l-4.34-4.34c-3.2 0-6 1.75-7.5 4.34a8.66 8.66 0 0 0 7.5 4.33Z" fill="#65A435"/></svg>
        <p
          class="grow text-24 font-semibold"
          v-html="$t(`app_prompt.${promptType}_copy`, { amount: incentive })"
        />
        <svg role="presentation" focusable="false" tabindex="-1" v-if="promptType !== 'generic'"
          class="flex-none h-20 -mt-2 -mr-2"
           
          alt=""
          svg-inline
         fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="31.6" cy="31.6" r="31.6" transform="scale(1 -1) rotate(32 168 15.5)" fill="#F0F0F0"/><path fill-rule="evenodd" clip-rule="evenodd" d="m29 25.4 23.5-1.6a2.5 2.5 0 0 1 2 .7L93 63.1a2.5 2.5 0 0 1 0 3.5l-25 25a2.5 2.5 0 0 1-3.6 0L25.8 53.2a2.5 2.5 0 0 1-.7-2l1.6-23.4a2.5 2.5 0 0 1 2.3-2.3ZM52 50.5a10.1 10.1 0 1 1-14.3-14.3 10.1 10.1 0 0 1 14.3 14.3Z" fill="#327CBF"/><path d="m57.2 67.6-.7-.7a4 4 0 0 1-1-1.8 3.5 3.5 0 0 1 .1-2c.2-.6.7-1.2 1.3-1.8.7-.6 1.3-1 2-1a3.4 3.4 0 0 1 2 0 4 4 0 0 1 1.6 1.2l.7.7A4 4 0 0 1 64 64a3.5 3.5 0 0 1 0 1.9c-.3.7-.7 1.3-1.3 1.9-.7.5-1.3.9-2 1a3.5 3.5 0 0 1-2 0 4 4 0 0 1-1.6-1.2Zm1-2.3.7.8.8.5.9.2c.3 0 .6-.2.9-.5l.5-.8a1.6 1.6 0 0 0 0-1 2.3 2.3 0 0 0-.6-.7l-.6-.8a2.3 2.3 0 0 0-.8-.5 1.6 1.6 0 0 0-.9-.2c-.3 0-.6.2-.9.5-.3.2-.4.5-.5.8v.9l.5.8ZM71 69.4l-.6-.7a4 4 0 0 1-1-1.8 3.6 3.6 0 0 1 .1-2c.2-.6.6-1.2 1.3-1.8.6-.6 1.3-1 2-1a3.5 3.5 0 0 1 2 0 4 4 0 0 1 1.6 1.2l.6.7a4 4 0 0 1 1 1.8 3.5 3.5 0 0 1 0 2c-.3.6-.7 1.2-1.4 1.8-.6.5-1.3 1-2 1-.6.2-1.3.2-2 0a4 4 0 0 1-1.6-1.2Zm1.1-2.3.7.8.8.5c.2.1.5.2.9.1.3 0 .6-.1.8-.4l.6-.9v-.8a2.8 2.8 0 0 0-.6-.8l-.6-.8a2.2 2.2 0 0 0-.8-.5 1.7 1.7 0 0 0-1-.2c-.2 0-.5.2-.8.5-.3.2-.5.5-.5.8v1l.5.7ZM66.2 57l3 17-1.9.4-3-17 2-.4Z" fill="#fff"/></svg>
      </div>

      <div>
        <p
          v-if="promptType !== 'generic'"
          class="mx-6 mt-4 text-18 font-normal"
          v-html="
            promptType === 'providers'
              ? $t('app_prompt.promo_copy_providers')
              : $t('app_prompt.promo_copy')
          "
        />
        <div v-if="promptType === 'generic'" class="mx-6 mt-4">
          <SellingPoints />
        </div>
        <div v-else-if="promptType === 'providers'" class="mx-6 mt-4 flex flex-col">
          <PromoProviders :providers="subsetProviders" />
        </div>
        <div class="flex mx-6" :class="promptType === 'providers' ? 'mt-4' : 'mt-8'">
          <a
            class="btn btn-sm btn-green mb-4 md:mb-0 w-full whitespace-nowrap"
            :href="link"
            target="_blank"
            rel="nofollow noopener"
            @click="trackClick"
          >
            {{ $t('app_prompt.get_the_app') }}
          </a>
        </div>
      </div>
    </div>
  </MModal>
</template>

<script lang="ts" setup>
import { AppPromptClick } from '@core/analytics/core-events/app'
import type { PromoProvider, PromptPromosType } from '../types'
import SellingPoints from './selling-points.vue'
import PromoProviders from './promo-providers.vue'

const props = defineProps<{
  promptType: PromptPromosType
  incentive?: string
  promoProviders?: PromoProvider[]
}>()

const open = ref(false)
const ONE_DAY = 86400000
const APP_PROMPT_KEY = 'hidePromosAppPrompt'

const { $track } = useNuxtApp()

onMounted(() => {
  setTimeout(async () => {
    const lastClosed = await storage.getValue(APP_PROMPT_KEY)
    if (lastClosed && Date.now() - Number(lastClosed) < ONE_DAY) {
      return
    }
    open.value = true
  }, 800)
})

const subsetProviders = props.promoProviders?.slice() ?? []
subsetProviders.length = Math.min(subsetProviders.length, 4)

const link = useAppLink(`prompt_hide_promos_${props.promptType}`)

async function trackClick() {
  await $track(AppPromptClick(`hide_promos_${props.promptType}`))
}

async function onClose() {
  open.value = false
  await storage.setValue(APP_PROMPT_KEY, String(Date.now()))
}
</script>
